// Markedslyset: seks tommelfingerregler profesjonelle bruker, hver grønn (+1), gul (0) eller rød (−1).
// Brukes både i «I dag» og i den daglige skanneren (functions/api/scan.js), så reglene er like begge steder.
// perf: svar fra /perf for SPY, RSP, ^VIX, ^VIX3M, HYG, LQD. gamma: { positive } fra gammaProfile (valgfri).

const fmtP = v => `${v >= 0 ? "+" : ""}${v.toFixed(1)}%`;

export function computeRegime(perf, gamma = null) {
  const s = perf?.SPY;
  if (!s) return null;
  const vix = perf["^VIX"]?.price, vix3m = perf["^VIX3M"]?.price, items = [];
  if (s.ma50 && s.ma200) {
    const v = s.price > s.ma50 && s.ma50 > s.ma200 ? 1 : s.price < s.ma200 ? -1 : 0;
    items.push({ v, label: "Trend (S&P 500)", val: `${s.price > s.ma50 ? "over" : "under"} 50d · ${s.price > s.ma200 ? "over" : "under"} 200d`,
      why: v === 1 ? "Opptrend: kursen over 50- og 200-dagers snitt" : v === -1 ? "Under 200-dagers snitt: nedtrend" : "Blandet: konsolidering eller trendskifte" });
  }
  if (vix) {
    const v = vix < 16 ? 1 : vix > 24 ? -1 : 0;
    items.push({ v, label: "Frykt (VIX)", val: vix.toFixed(1), why: v === 1 ? "Rolig marked" : v === -1 ? "Høy frykt og store svingninger" : "Normalt nivå" });
  }
  if (vix && vix3m) {
    const r = vix / vix3m, v = r < 0.9 ? 1 : r > 1 ? -1 : 0;
    items.push({ v, label: "VIX-kurven (VIX / VIX3M)", val: r.toFixed(2), why: v === -1 ? "Kortsiktig frykt over langsiktig: akutt stress" : v === 1 ? "Normal kurve: ingen akutt uro" : "Flat kurve: uroen øker" });
  }
  if (perf.HYG?.m1 != null && perf.LQD?.m1 != null) {
    const d = perf.HYG.m1 - perf.LQD.m1, v = d > -0.5 ? 1 : d < -1.5 ? -1 : 0;
    items.push({ v, label: "Kreditt (HYG mot LQD, 1 mnd)", val: fmtP(d), why: v === 1 ? "Risikable obligasjoner holder seg: investorene tar risiko" : v === -1 ? "Flukt fra risikable obligasjoner: ofte et tidlig faresignal" : "Litt svakere risikovilje" });
  }
  if (perf.RSP?.m1 != null && s.m1 != null) {
    const d = perf.RSP.m1 - s.m1, v = d > -1 ? 1 : d < -3 ? -1 : 0;
    items.push({ v, label: "Bredde (likevektet mot S&P, 1 mnd)", val: fmtP(d), why: v === 1 ? "Bred oppgang: mange aksjer er med" : v === -1 ? "Smal oppgang: få store aksjer bærer markedet" : "Litt smal bredde" });
  }
  if (gamma) {
    const v = gamma.positive ? 1 : -1;
    items.push({ v, label: "Dealer-gamma (SPY)", val: gamma.positive ? "positiv" : "negativ", why: v === 1 ? "Markedsmakerne demper svingningene" : "Markedsmakerne forsterker bevegelsene: større dagsutslag" });
  }
  const sum = items.reduce((a, b) => a + b.v, 0), level = sum >= 3 ? 1 : sum <= -1 ? -1 : 0;
  return {
    items, level,
    name: level === 1 ? "grønt" : level === -1 ? "rødt" : "gult",
    title: level === 1 ? "GRØNT · risiko på" : level === -1 ? "RØDT · forsiktig" : "GULT · selektiv",
    hint: level === 1 ? "Medvind. Trendfølgende kjøp i de sterkeste aksjene har best odds."
      : level === -1 ? "Motvind. Mindre posisjoner, sikre gevinster, eller vent på bedre forhold."
      : "Blandet. Bare de sterkeste oppsettene, og hold posisjonene små.",
  };
}

// «Følg bølgen»-ledere: opptrend (kurs > 50d > 200d) og blant de 25 % sterkeste mot S&P 500 siste 3 måneder.
// Backtesten (AI-aksjer, 5 år) ga +6,1 % snitt neste 20 dager mot +3,6 % for de svakeste.
export function findLeaders(perf, tickers) {
  const spy = perf?.SPY;
  if (spy?.m3 == null) return [];
  const rows = tickers.filter(t => perf[t]?.m3 != null).map(t => ({ t, ...perf[t], rs3: perf[t].m3 - spy.m3 }))
    .sort((a, b) => b.rs3 - a.rs3);
  const cut = Math.max(1, Math.ceil(rows.length / 4));
  return rows.slice(0, cut).filter(r => r.ma50 && r.ma200 && r.price > r.ma50 && r.ma50 > r.ma200);
}
